module.exports = __webpack_public_path__ + "static/media/ConstructionService.06ef7457.jpg";